// extracted by mini-css-extract-plugin
export var articles = "series-module--articles--2G7y1";
export var article = "series-module--article--3kLQz";